import React from 'react';
import { Page } from '../Page';
import { PullQuote } from '../PullQuote';
export function PagePlateaus() {
  return <Page pageNumber={38} variant="light" data-id="element-1359">
      <div className="flex h-full gap-12" data-id="element-1360">
        {/* Left 1/3 Column */}
        <div className="w-1/3 flex flex-col pt-32" data-id="element-1361">
          <PullQuote text="A plateau is not a failure. It is a signal to review your habits." variant="light" data-id="element-1362" />

          <div className="mt-auto border-t border-[#D8D8D0] pt-6" data-id="element-1363">
            <h3 className="font-bold text-[#1F1F1F] text-xs mb-2" data-id="element-1364">Remember</h3>
            <p className="text-[11px] text-[#7A7A70] leading-[1.6]" data-id="element-1365">
              Refer back to the "Managing Your Dose" page. A plateau is one of
              the few times increasing your dose might be the right next step,
              but only if your habits are dialed in.
            </p>
          </div>
        </div>

        {/* Right 2/3 Column */}
        <div className="w-2/3 flex flex-col" data-id="element-1366">
          <div className="mb-8 pt-4" data-id="element-1367">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1368">
              Challenges
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1369">
              Navigating <span className="text-tealslate" data-id="element-1370">Plateaus</span>
            </h1>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-1371" />
          </div>

          <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8" data-id="element-1372">
            A plateau is not a failure. It is a normal, expected part of the
            weight loss process. Your body is designed to fight weight loss to
            protect you from starvation. When you lose weight, your metabolism
            slows down to match your new, smaller body size.
          </p>

          <div className="border-l-4 border-tealslate pl-5 py-4 bg-[#EAEAE4] border-y border-r border-[#D8D8D0] mb-8" data-id="element-1373">
            <p className="text-sm font-serif text-[#1F1F1F] leading-[1.6]" data-id="element-1374">
              A true plateau is 4 weeks with no change in weight AND no change
              in measurements.
            </p>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 mb-8" data-id="element-1375">
            <h3 className="font-serif text-lg text-[#1F1F1F] mb-4" data-id="element-1376">
              Before assuming a true plateau, check:
            </h3>
            <ul className="space-y-3 text-xs text-[#7A7A70]" data-id="element-1377">
              <li className="flex items-center gap-3" data-id="element-1378">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1379" />
                Are you sleeping enough?
              </li>
              <li className="flex items-center gap-3" data-id="element-1380">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1381" />
                Are you hydrated?
              </li>
              <li className="flex items-center gap-3" data-id="element-1382">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1383" />
                Are you hitting your protein targets?
              </li>
              <li className="flex items-center gap-3" data-id="element-1384">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1385" />
                Are you lifting weights consistently?
              </li>
              <li className="flex items-center gap-3" data-id="element-1386">
                <div className="w-1.5 h-1.5 rounded-full bg-tealslate shrink-0" data-id="element-1387" />
                Are you under high stress?
              </li>
            </ul>
          </div>

          <div className="space-y-4 text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1388">
            <p data-id="element-1389">
              <strong className="text-[#1F1F1F]" data-id="element-1390">Common causes:</strong>{' '}
              Metabolic adaptation, water retention, muscle gain offsetting fat
              loss, or inconsistent tracking.
            </p>
            <p data-id="element-1391">
              <strong className="text-[#1F1F1F]" data-id="element-1392">What to do:</strong> Review the
              fundamentals first. Consider tracking calories temporarily to
              ensure you are still in a deficit. Talk to your provider about a
              dose adjustment only after addressing your habits.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}